import { type ReactNode } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import type { MenuProps } from "antd";
import "./journal-section-records-toolbar.scss";

type JournalSectionRecordsToolbarProps = {
  addButton: ReactNode;
  onStartBulkSign?: () => void;
  showBulkActions?: boolean;
};

export const JournalSectionRecordsToolbar = ({
  addButton,
  onStartBulkSign,
  showBulkActions = true,
}: JournalSectionRecordsToolbarProps) => {
  const menuItems: MenuProps["items"] = [
    {
      key: "bulk-sign",
      label: "Отправка на подписание",
      onClick: onStartBulkSign,
    },
  ];

  const actionsRow = (
    <div className="journal-section-records-toolbar__row">
      {showBulkActions ? (
        <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
          <Button>
            Действия с записями <DownOutlined />
          </Button>
        </Dropdown>
      ) : null}

      {addButton}
    </div>
  );

  return (
    <div className="journal-section-records-toolbar">
      {actionsRow}
    </div>
  );
};
